document.addEventListener("DOMContentLoaded", (event) => {
    // for _custom-paging.blade and _paginate.blade - if it is in a modal, load up the modal body
    $(document).on('click', '.paginate .custom, .paginate .custom-previous, .paginate .custom-next', function (e) {
        const $link = $(this);
        const $modalBody = $link.closest('.modal-body');

        if ($modalBody.length > 0) {
            e.preventDefault();
            const url = $link.attr('href');

            $.get(url, function (data) {
                $modalBody.html(data);
            });
        }
    });

});
